import * as React from 'react';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Box, useMediaQuery, useTheme,
} from '@mui/material';
import CustomHeader from '../components/CustomHeader';
import cutplusdrylogo from '../assets/Images/cutplusdry.svg';
import emojotlogo from '../assets/Images/emojot.webp';
import cutdrydoc from '../assets/docs/ADScAI 2026 Cut+Dry — Workshop Proposal.pdf'
import emojotdoc from '../assets/docs/ADScAI_Emojot.pdf'

// --- ICONS ---

const CalendarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <rect x="1" y="2" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
        <path d="M1 5h12" stroke="currentColor" strokeWidth="1.2" />
        <path d="M4 1v2M10 1v2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

const ClockIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2" />
        <path d="M7 4v3.5l2 1.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const LocationIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <path d="M7 1C4.79 1 3 2.79 3 5c0 3.5 4 8 4 8s4-4.5 4-8c0-2.21-1.79-4-4-4z" stroke="currentColor" strokeWidth="1.2" />
        <circle cx="7" cy="5" r="1.5" stroke="currentColor" strokeWidth="1.2" />
    </svg>
);

// --- WORKSHOP DATA ---

const WORKSHOPS = [
    {
        title: 'Designing Event-Driven AI Systems on AWS: From Signals to Intelligent Actions at Scale',
        sponsorLogo: emojotlogo,
        sponsorName: 'Emojot Team',
        sponsorRole: 'Industry Expert',
        sponsorInitials: 'EJ',
        accentColor: '#1565C0',
        avatarBg: '#BBDEFB',
        avatarColor: '#0D47A1',
        date: '28 Apr 2026',
        time: '8:00 AM - 12:00 NOON',
        venue: 'University of Moratuwa, Department of CSE',
        link: emojotdoc,
    },
    {
        title: 'Beyond Vibe Coding: Shipping Real Features with AI Agents',
        sponsorLogo: cutplusdrylogo,
        sponsorName: 'Cut+Dry Team',
        sponsorRole: 'Industry Expert',
        sponsorInitials: 'CD',
        accentColor: '#1565C0',
        avatarBg: '#BBDEFB',
        avatarColor: '#0D47A1',
        date: '28 Apr 2026',
        time: '1:00 PM - 5:00 PM',
        venue: 'University of Moratuwa, Department of CSE',
        link: cutdrydoc,
    },
];

// --- COMPONENT ---

const Workshops = () => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Container id="workshops" maxWidth="lg" sx={{ py: 5 }}>
            <CustomHeader value="Workshops" sx={{ mb: 3 }} />

            <Grid container spacing={3} paddingY="20px" paddingX="28px">
                <Grid item xs={12}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                        Explore Our Workshops
                    </Typography>
                    <Typography variant="body1" color="textSecondary" sx={{ mt: 1 }}>
                        Join our hands-on workshops led by industry experts and enhance your practical knowledge.<br/>
                        A participation certificate will be provided to registered participants
                    </Typography>
                    <Box
                        sx={{
                            mt: 3,
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                        }}
                    >
                        {/*<Button*/}
                        {/*    variant='contained'*/}
                        {/*    href='https://forms.gle/j8DwcJjsYFXNsPsf9'*/}
                        {/*    target='_blank'*/}
                        {/*    sx={{*/}
                        {/*        bgcolor: '#1565C0',*/}
                        {/*        color: 'white',*/}
                        {/*        fontWeight: 600,*/}
                        {/*        borderRadius: '8px',*/}
                        {/*        textTransform: 'none',*/}
                        {/*        px: isSmallScreen ? 2 : 4,*/}
                        {/*        py: isSmallScreen ? 1 : 1.5,*/}
                        {/*        fontSize: isSmallScreen ? '0.875rem' : '1rem',*/}
                        {/*        '&:hover': {*/}
                        {/*            backgroundColor: '#1565C0',*/}
                        {/*            opacity: 0.88,*/}
                        {/*        },*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    Register Now*/}
                        {/*</Button>*/}
                    </Box>
                </Grid>

                {WORKSHOPS.map((workshop, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                        <Card
                            sx={{
                                borderRadius: 3,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                overflow: 'hidden',
                                border: '1px solid rgba(0,0,0,0.08)',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                },
                            }}
                        >
                            {/* Accent bar */}
                            <Box sx={{ height: '5px', backgroundColor: workshop.accentColor }} />

                            <CardContent sx={{ pt: 2.5, pb: 1 }}>
                                <Typography variant='h5' fontWeight='bold' gutterBottom>
                                    {workshop.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        letterSpacing: '0.08em',
                                        textTransform: 'uppercase',
                                        color: 'text.disabled',
                                        my: 1,
                                        textAlign: 'center',
                                    }}
                                >
                                    Conducted by
                                </Typography>

                                {/* Sponsor logo */}
                                <Box
                                    component="img"
                                    src={workshop.sponsorLogo}
                                    alt="Sponsor Logo"
                                    sx={{
                                        width: '100%',
                                        height: '70px',
                                        objectFit: 'contain',
                                        mb: 2,
                                    }}
                                />

                                {/* Meta rows */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mb: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'text.secondary', fontSize: 13 }}>
                                        <CalendarIcon />
                                        <Typography variant="body1" color="text.secondary">
                                            {workshop.date}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'text.secondary' }}>
                                        <ClockIcon />
                                        <Typography variant="body1" color="text.secondary">
                                            {workshop.time}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'text.secondary' }}>
                                        <LocationIcon />
                                        <Typography variant="body1" color="text.secondary">
                                            {workshop.venue}
                                        </Typography>
                                    </Box>
                                </Box>

                            </CardContent>
                            <CardActions sx={{ p: 2, pt: 1 }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    href={workshop.link}
                                    target="_blank"
                                    sx={{
                                        backgroundColor: workshop.accentColor,
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        py: 1,
                                        '&:hover': {
                                            backgroundColor: workshop.accentColor,
                                            opacity: 0.88,
                                        },
                                    }}
                                >
                                    View More
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Workshops;